// extracted by mini-css-extract-plugin
export default {"control":"Control_control__ml3AK","button":"Control_button__EVTf0"};